/** Namespace `partnerReport` — BANK-2026-039: báo cáo đối tác (Tingee, SePay) của bube-banktransfer. Bản gốc tiếng Việt. */
export const partnerReport = {
  title: "Báo cáo đối tác",
  intro: "Mọi số liệu đối tác ngân hàng báo về (Tingee, SePay) đặt cạnh số Bube nhận — theo nhà cung cấp và theo công ty. Không phải vào portal đối tác để đếm tay.",
  month: "Tháng",
  loadFailed: "Không tải được báo cáo đối tác.",
  refresh: "Làm mới",
  refreshing: "Đang xếp…",
  refreshQueued: "Đã xếp lượt chụp {provider} — số mới sau vài phút.",
  refreshCooldown: "{provider} vừa làm mới — thử lại sau {at}.",
  stale: "Số cũ",
  lastCollected: "Chụp lúc {at}",
  neverCollected: "Chưa có snapshot — job chụp 6 giờ một lần, hoặc bấm « Làm mới ».",
  truncated: "Đối tác trả quá nhiều trang — số có thể THIẾU (không kết luận « thiếu ở đối tác »).",
  "tab.overview": "Tổng quan",
  "tab.merchants": "Công ty",
  "tab.discrepancies": "Đối chiếu",
  "tab.apis": "Nguồn API",
  "tab.budgets": "Ngân sách",
  "tab.wallet": "Ví & hạn mức",
  "env.live": "Thật",
  "env.test": "Thử",
  "provider.tingee": "Tingee",
  "provider.sepay_bankhub": "SePay Bank Hub",
  "provider.sepay_webhook": "SePay (khách uỷ quyền)",
  "provider.gpmpay_webhook": "GPMPay",
  merchants: "Công ty",
  users: "Người dùng",
  branches: "Chi nhánh",
  shops: "Cửa hàng ở đối tác",
  accounts: "Tài khoản",
  vas: "VA",
  devices: "Thiết bị",
  orphanUnits: "Đơn vị mồ côi ở đối tác",
  txPartner: "Giao dịch (đối tác báo)",
  txBube: "Giao dịch (Bube nhận)",
  amountPartner: "Tiền vào (đối tác báo)",
  amountBube: "Tiền vào (Bube nhận)",
  missedWebhook: "Webhook đối tác chưa gửi được",
  rejectedHooks: "Lượt webhook bị từ chối",
  prevMonth: "Tháng trước: đối tác {partner} · Bube {bube}",
  unknown: "không biết",
  cost: "Chi phí ước tính tháng này",
  costPrev: "Tháng trước",
  "costBasis.partner": "tính theo số đối tác báo",
  "costBasis.bube": "tính theo số Bube nhận (đối tác không báo)",
  window: "Đối tác có số {covered}/{elapsed} ngày của tháng{from}",
  windowFrom: " (từ {day})",
  txBubeCovered: "Bube cùng kỳ: {n}",
  txBubeMonth: "Bube cả tháng",
  nothingToCollect: "Không có gì để chụp — đối tác chưa bật ở hub cho môi trường này, hoặc chưa có kết nối nào.",
  usersUnknown: "{n} công ty không biết (người dùng ở app cấp công ty)",
  "origin.partner": "qua {app}",
  "origin.ecosystem": "liên kết hệ sinh thái",
  "origin.system": "công ty hệ thống",
  "origin.bube": "đăng ký ở Bube",
  "costBasis.mixed": "trộn: đối tác cho ngày có số + Bube nhận cho ngày còn lại",
  "detail.covered_days": "so trên {n} ngày đối tác có số",
  "detail.revoked_connection": "kết nối của công ty {id} đã thu hồi mà ở đối tác vẫn còn",
  "errorHint.1133": "khoá thiếu quyền chức năng này — xin Tingee mở nhóm API",
  "errorHint.1004": "khoá thiếu quyền chức năng này — xin Tingee mở nhóm API",
  txOutHint: "+ {n} giao dịch ra",
  txBubeSame: "Bube cùng kỳ",
  noPricing: "Chưa cấu hình giá cho bộ thông số đang gán — vào « Tích hợp đối tác ».",
  customerPays: "Khách tự trả đối tác — không phải chi phí của Bube.",
  quota: "Đã dùng {pct} hạn mức gói",
  "model.per_transaction": "Theo giao dịch",
  "model.monthly_capped": "Theo tháng, có hạn mức",
  "model.monthly_unlimited": "Theo tháng, không giới hạn",
  "scope.per_account": "mỗi tài khoản",
  "scope.per_company": "mỗi công ty",
  "scope.per_contract": "cả hợp đồng",
  account: "Tài khoản Bube ở đối tác",
  accountWebhook: "Webhook cấp tài khoản",
  "webhook.ok": "trỏ đúng Bube",
  "webhook.mismatch": "KHÔNG trỏ về Bube",
  "webhook.missing": "chưa đăng ký",
  "webhook.inactive": "đang tắt",
  coverage: "API đã gọi: {ok}/{total} ổn",
  budgetOf: "Ngân sách: {spent} / {limit} ({pct})",
  "level.ok": "trong ngân sách",
  "level.warn": "≥ 80 % ngân sách",
  "level.over": "VƯỢT ngân sách",
  company: "Công ty",
  provider: "Đối tác",
  connections: "Kết nối (chạy · dừng · khác)",
  quotaCol: "Hạn mức",
  quotaUnlimited: "Không giới hạn",
  tx: "Giao dịch đối tác / Bube cùng kỳ",
  amount: "Tiền vào đối tác / Bube",
  costCol: "Chi phí",
  scopes: "Thiếu quyền",
  suspended: "Bị đình chỉ",
  detail: "Chi tiết",
  close: "Đóng",
  exportCsv: "Xuất CSV",
  noMerchants: "Chưa có công ty nào dùng đối tác này.",
  filter: "Lọc theo tên / id công ty",
  detailTitle: "{name} — {month}",
  detailLoading: "Đang tải chi tiết…",
  units: "Đơn vị ở đối tác",
  daily: "Theo ngày (giờ VN)",
  date: "Ngày",
  owner: "Chủ tài khoản đối tác",
  subscription: "Gói đối tác",
  noUnits: "Đối tác chưa báo đơn vị nào của công ty này.",
  "kind.tx_count": "Lệch số giao dịch",
  "kind.partner_unit_orphan": "Đơn vị ở đối tác không gắn công ty Bube",
  "kind.va_orphan_at_partner": "VA đang chạy ở đối tác, Bube không biết",
  "kind.va_missing_at_partner": "Kết nối có VA mà đối tác không liệt kê",
  "kind.status_mismatch": "Bube đang chạy, đối tác báo VA không hoạt động",
  "kind.webhook_missing": "Webhook chưa đăng ký ở đối tác",
  "kind.webhook_mismatch": "Webhook lệch (tắt / không trỏ về Bube)",
  "kind.missed_webhook": "Đối tác ghi webhook chưa gửi được",
  "kind.quota_exceeded": "Chạm / vượt hạn mức giao dịch của đối tác",
  noDiscrepancies: "Không có lệch nào.",
  bubeVsPartner: "Bube {bube} · đối tác {partner}",
  api: "API",
  purpose: "Dùng để",
  readStatus: "Trạng thái",
  "status.reported": "Có trong báo cáo",
  "status.not_applicable": "Không áp dụng",
  reason: "Lý do",
  lastOutcome: "Lần gọi gần nhất",
  "outcome.ok": "ổn",
  "outcome.forbidden_scope": "thiếu quyền",
  "outcome.error": "lỗi",
  "outcome.not_configured": "chưa cấu hình",
  "outcome.truncated": "bị cắt trang",
  "outcome.skipped": "bỏ qua",
  never: "chưa gọi",
  budgetsTitle: "Ngân sách chi phí đối tác",
  budgetsIntro: "Ngân sách tháng theo sản phẩm (cả nhà cung cấp) hoặc trần riêng một công ty. Đổi ngân sách = thêm mức có hiệu lực từ ngày mới; mức đã áp là lịch sử. Chạm 80 % / 100 % ⇒ mục ở « Cần xử lý ».",
  product: "Sản phẩm",
  scopeAll: "Cả nhà cung cấp",
  workspaceId: "Id công ty (để trống = cả nhà cung cấp)",
  monthly: "Ngân sách / tháng (₫)",
  effectiveFrom: "Hiệu lực từ",
  note: "Ghi chú",
  add: "Thêm ngân sách",
  remove: "Xoá",
  "budget.current": "đang áp",
  "budget.future": "sắp áp",
  "budget.past": "đã thay",
  noBudgets: "Chưa có ngân sách nào.",
  budgetSaved: "Đã lưu ngân sách.",
  budgetInvalid: "Nhập ngân sách là số nguyên dương (đồng).",
} as const;
